import { CustomAdUnitConfig } from '@/types'

export const PORTAL_FALLBACK_CONFIG: CustomAdUnitConfig[] = [
    {
        platforms: ['desktop'],
        campaignId: 'fallback_no_ads_eye',
        creatives: [
            {
                adUnits: ['leaderboard'],
                format: 'banner',
                file: 'bcb2cf74-d18f-46db-88b8-cf2954f34d00',
                clickUrl: 'https://playgama.com/developers',
                width: 728,
                height: 90,
            },
            {
                adUnits: ['leaderboard_rest'],
                format: 'banner',
                file: 'bcb2cf74-d18f-46db-88b8-cf2954f34d00',
                clickUrl: 'https://playgama.com/developers',
                width: 728,
                height: 90,
            },
            {
                adUnits: ['sidebar_bottom'],
                format: 'banner',
                file: '374a2dc4-458e-4af1-5256-35f309f0a400',
                clickUrl: 'https://playgama.com/developers',
                width: 300,
                height: 600,
            },
        ],
    },
    {
        platforms: ['desktop'],
        campaignId: 'fallback_no_ads_balls',
        creatives: [
            {
                adUnits: ['leaderboard'],
                format: 'banner',
                file: 'dccaa1b8-a6d0-4569-70a9-b752c115be00',
                clickUrl: 'https://playgama.com/developers',
                width: 728,
                height: 90,
            },
            {
                adUnits: ['leaderboard_rest'],
                format: 'banner',
                file: 'dccaa1b8-a6d0-4569-70a9-b752c115be00',
                clickUrl: 'https://playgama.com/developers',
                width: 728,
                height: 90,
            },
            {
                adUnits: ['sidebar_bottom'],
                format: 'banner',
                file: '979162c2-542d-446b-63cc-9afa4b7ceb00',
                clickUrl: 'https://playgama.com/developers',
                width: 300,
                height: 600,
            },
        ],
    },
    {
        platforms: ['desktop'],
        campaignId: 'fallback_no_ads_fruits',
        creatives: [
            {
                adUnits: ['sidebar_bottom'],
                format: 'banner',
                file: 'c58e10aa-cd01-4623-b108-f1ce19f24500',
                clickUrl: 'https://playgama.com/developers',
                width: 300,
                height: 600,
            },
            {
                adUnits: ['leaderboard'],
                format: 'banner',
                file: '18ed08fd-1859-4757-ca7c-2bfbf988cf00',
                clickUrl: 'https://playgama.com/developers',
                width: 728,
                height: 90,
            },
            {
                adUnits: ['leaderboard_rest'],
                format: 'banner',
                file: '18ed08fd-1859-4757-ca7c-2bfbf988cf00',
                clickUrl: 'https://playgama.com/developers',
                width: 728,
                height: 90,
            },
        ],
    },
    {
        platforms: ['android', 'ios'],
        campaignId: 'fallback_no_ads_eye',
        creatives: [
            {
                adUnits: ['leaderboard'],
                format: 'banner',
                file: 'bcb2cf74-d18f-46db-88b8-cf2954f34d00',
                clickUrl: 'https://playgama.com/developers',
                width: 728,
                height: 90,
            },
            {
                adUnits: ['leaderboard_rest'],
                format: 'banner',
                file: 'bcb2cf74-d18f-46db-88b8-cf2954f34d00',
                clickUrl: 'https://playgama.com/developers',
                width: 728,
                height: 90,
            },
            {
                adUnits: ['sidebar_bottom'],
                format: 'banner',
                file: '374a2dc4-458e-4af1-5256-35f309f0a400',
                clickUrl: 'https://playgama.com/developers',
                width: 300,
                height: 600,
            },
        ],
    },
    {
        platforms: ['android', 'ios'],
        campaignId: 'fallback_no_ads_balls',
        creatives: [
            {
                adUnits: ['leaderboard'],
                format: 'banner',
                file: 'dccaa1b8-a6d0-4569-70a9-b752c115be00',
                clickUrl: 'https://playgama.com/developers',
                width: 728,
                height: 90,
            },
            {
                adUnits: ['leaderboard_rest'],
                format: 'banner',
                file: 'dccaa1b8-a6d0-4569-70a9-b752c115be00',
                clickUrl: 'https://playgama.com/developers',
                width: 728,
                height: 90,
            },
            {
                adUnits: ['sidebar_bottom'],
                format: 'banner',
                file: '979162c2-542d-446b-63cc-9afa4b7ceb00',
                clickUrl: 'https://playgama.com/developers',
                width: 300,
                height: 600,
            },
        ],
    },
]
